import React from 'react';
import FearGreedGauge from '../../components/ui/FearGreedGauge';
import WorkspaceTabs from '../../components/ui/WorkspaceTabs';
import { STOCKS_TABS } from './stocksTabs';

/**
 * Stocks workspace — Fear & Greed sub-page.
 * Renders only the CNN Fear & Greed gauge (data + methodology).
 */
export default function StocksFearGreedPage() {
  return (
    <div style={s.page}>
      <h1 style={s.title}>Stocks Fear &amp; Greed</h1>
      <p style={s.subtitle}>
        Market sentiment for US equities from CNN Business — a 0 to 100 score
        combining seven indicators of fear and greed in the stock market.
      </p>

      <WorkspaceTabs tabs={STOCKS_TABS} />

      <FearGreedGauge
        endpoint="/api/sentiment/fear-greed/stocks"
        title="Stocks Fear &amp; Greed Index"
      />
    </div>
  );
}

const s = {
  page: { padding: '0 0 48px' },
  title: { margin: 0, fontSize: '26px', fontWeight: 800, color: 'var(--text-primary)' },
  subtitle: { margin: '4px 0 20px', fontSize: '14px', color: 'var(--text-secondary)', maxWidth: '720px' },
};
